import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { updateRosterSpareConfirmation } from '@sportninja/common/services/game/rosterSpareConfirmService'

interface Params {
  gameId?: string
  rosterId?: string
}

export interface ConfirmRosterSpareVariables {
  playerId: string
  confirmed: boolean
}

/**
 * SN-8476 — a team official confirms / unconfirms a roster spare for this
 * game. Refetches the roster on success (awaited, so `mutateAsync` resolves
 * only once the list reflects the change); toasts on failure.
 */
export const useConfirmRosterSpare = ({ gameId, rosterId }: Params) => {
  const queryClient = useQueryClient()
  const { message } = App.useApp()

  return useMutation<void, Error, ConfirmRosterSpareVariables>({
    mutationFn: ({ playerId, confirmed }) =>
      updateRosterSpareConfirmation({
        gameId: gameId as string,
        rosterId: rosterId as string,
        playerId,
        confirmed,
      }),
    retry: 0,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.gameRosterPlayers.byRoster(gameId, rosterId),
      }),
    onError: (e) => {
      message.error(`Unable to update confirmation: ${e.message}`)
    },
  })
}
